/* globals Swiper */
import 'swiper';

export default {
  init() {
    // JavaScript to be fired on the gallery page
    // $(document).ready(function(){

      var mySwiper = new Swiper ('.swiper-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,

      // If we need pagination
      // pagination: '.swiper-pagination',

      // Navigation arrows
      nextButton: '.button-next',
      prevButton: '.button-prev',
      onClick: function(){
        mySwiper.slideNext();
      },

      // And if we need scrollbar
      // scrollbar: '.swiper-scrollbar',
    })
  // });
    // $(document).ready(function(){
    //   console.log('here'); // eslint-disable-line
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGallery.js